<div class="progress-wrap-autoplay flex items-center gap-1">
  <dojo-icon-button
    class="back-button"
    [disabled]="state.isFirstSlide"
    (click)="slideBack()"
    [icon]="'arrow-left'"
    [transparent]="true"
    [iconSize]="18"
  ></dojo-icon-button>

  <div class="progress-bar-container">
    @for (segment of state.totalSlides; track $index) {
      <button
        class="progress-segment"
        (click)="goToSlide($index)"
        [class.completed]="$index < swiperInstance().activeIndex"
        [class.active]="swiperInstance().activeIndex === $index"
      >
        <div
          [hidden]="swiperInstance().activeIndex !== $index"
          class="progress-fill"
          [style.--progress]="state.autoplayProgress + '%'"
        ></div>
      </button>
    }
  </div>
</div>
